// @flow
import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  MdDirectionsBus,
  MdAdd,
  MdSearch,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import OpenButton from '../../OpenButton';
import Input from '../../Input';
import CardHeader from '../../CardHeader';
import CardHeaderTitleContainer from '../../CardHeaderTitleContainer';
import CardHeaderTitle from '../../CardHeaderTitle';
import CardHeaderIcon from '../../CardHeaderIcon';
import CardHeaderLeftGroup from '../../CardHeaderLeftGroup';
import CardHeaderRightGroup from '../../CardHeaderRightGroup';
import CardContent from '../../CardContent';
import Popup from '../../Popup';
import CreateBusPopupContent from '../../CreateBusPopupContent';
import BusListTable from '../../BusListTable';
import { changeBusFilters, fetchSchoolBusesStarted } from '../../../actions/buses';
import { CreateButton, Search } from '../../CommonTexts';


const RoutesView = ({ changeFilters }) => (
  <Fragment>
    <CardHeader size="big">
      <CardHeaderLeftGroup>
        <CardHeaderIcon Icon={MdDirectionsBus} />
        <CardHeaderTitleContainer>
          <CardHeaderTitle title={i18n.t('common.bus', { count: 2 })} />
        </CardHeaderTitleContainer>
        <Popup
          id="createBus"
          theme="main"
          transitionMs={600}
        >
          <CreateBusPopupContent />
        </Popup>
      </CardHeaderLeftGroup>
      <CardHeaderRightGroup>
        <OpenButton
          id="createBus" 
          title={CreateButton(i18n.t('common.bus', { count: 1 }))}
          Icon={MdAdd} clearMargins
          style={{ marginRight: '2rem' }}
        />
        <Input
          placeholder={Search(i18n.t('common.bus', { count: 1 }), 1)}
          Icon={MdSearch}
          clearMargins
          onChange={
            ({ target }) => changeFilters(target.value)
          }
        />
      </CardHeaderRightGroup>
    </CardHeader>
    <CardContent>
      <BusListTable />
    </CardContent>
  </Fragment>
);

export default connect(
  undefined,
  dispatch => ({
    changeFilters(filter: string) {
      dispatch(changeBusFilters(filter));
      dispatch(fetchSchoolBusesStarted(1, filter));
    },
  }),
)(withRouter(RoutesView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendBusesView/index.jsx